<template>
    <LayoutAuth>
        <template #default>
            <b-form @submit.prevent>
                <FormValidator :validator="$v.form.email" v-slot="slotProps" class="mb-3">
                    <b-form-input
                        v-model="form.email"
                        :placeholder="$t('emailAddress').toLowerCase()"
                        :state="slotProps.state"
                        :disabled="submitting"
                        @keyup.enter="handleSubmit()"
                    />
                </FormValidator>
                <b-form-group>
                    <ButtonIcon
                        :loading="submitting"
                        :flip-icon="true"
                        variant="brand"
                        size="lg"
                        class="btn-login"
                        block
                        @click="handleSubmit()"
                    >
                        <template #default>
                            {{ $t('next') }}
                        </template>
                        <template #icon>
                            <img src="@/assets/arrow-button.svg" alt="" width="45px" class="ml-2">
                        </template>
                    </ButtonIcon>
                </b-form-group>
            </b-form>
        </template>
        <template #page-title>
            {{ $t('auth.resetPassword') }}
        </template>
        <template #login-as-buttons></template>
        <template #cta-link>
            <router-link :to="{name: 'Login'}" class="text-brand">
                {{ $t('auth.backToTheLoginPage') }}
            </router-link>
        </template>
    </LayoutAuth>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import AuthMixin from './auth-mixin.vue';

    export default {
        name: 'ResetPassword',
        mixins: [AuthMixin],
        data() {
            return {
                form: {
                    email: '',
                },
            };
        },
        validations: {
            form: {
                email: { required, email },
            },
        },
        methods: {
            formRequest() {
                return this.$store.dispatch('auth/resetPassword', { email: this.form.email });
            },
            requestSuccess() {
                this.resetForm();
                this.$toastr.success(this.$t('auth.pageResetPassword.successMessage'));
            },
        },
    };
</script>
